import React, { useEffect } from "react";
import VideoPlayer from "../components/LiveTest";
import axios from "axios";
import config from "../config";

const TestStream = () => {
  useEffect(() => {
    const prevHtmlOverflow = document.documentElement.style.overflow;
    const prevBodyOverflow = document.body.style.overflow;
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";

    const arr = window.location.pathname.split("/");
    axios
      .post(config.host + "/api/v1/live/stream/detail", {
        id: arr[2],
        userid: localStorage.StudioUserID,
      })
      .catch(() => {});

    return () => {
      document.documentElement.style.overflow = prevHtmlOverflow;
      document.body.style.overflow = prevBodyOverflow;
    };
  }, []);

  const videoJsOptions = {
    autoplay: true,
      muted: false,
    controls: true,
    responsive: true,
    liveui: true,
    controlBar: {
      volumePanel: {
        inline: true,
      },
      pictureInPictureToggle: true,
    },
    sources: [],
  };

  return (
    <div className="test-stream-page">
      <VideoPlayer
        id="video-area"
        className=""
        type="test"
        {...videoJsOptions}
      />
    </div>
  );
};

export default TestStream;
